<template>
  <div class="user-details vx-row w-full">
    <div v-if="!loading" class="vx-col relative">
      <h1>{{userDetails.selectedStudent.displayName}}</h1>
      <h4 class="mb-2 primary-color" >{{userDetails.selectedGrade.grade}} {{userDetails.selectedGradeSubject && userDetails.selectedGradeSubject.subject ? `| ${userDetails.selectedGradeSubject.subject}` : null}}</h4>
      <double-slider :width="250" :avgTime="avgTime" :myTime="myTime" ><h6 class="absolute time-spent">Time Spent:</h6></double-slider>
      <h5 class="data-my-avg mt-3" >My Average</h5>
      <h5 class="data-avg">Class Average</h5>
    </div>
    <div v-if="loading" class="vx-col relative mb-4">
      <custom-skeleton class="mt-2" animation="wave" type="text" :count="1" height="50px" width="250px"/>
      <custom-skeleton animation="wave" type="text" :count="1" height="25px" width="100px"/>
      <custom-skeleton animation="wave" type="text" :count="1" height="50px" width="250px"/>
      <custom-skeleton animation="wave" type="text" :count="1" height="25px" width="100px"/>
      <custom-skeleton animation="wave" type="text" :count="1" height="25px" width="100px"/>
    </div>
    <div v-if="!loading" class="vx-col">
      <custom-radial-chart v-if="!radialData.every(item => item === 0)"  class="radial-move" height="250" width="300" :series="radialData" />
      <h3 v-if="avgTime == 0 && myTime == 0 && radialData.every(item => item === 0)">No data</h3>
    </div>
    <div v-if="loading" class="vx-col">
      <custom-skeleton class="ml-5 mt-4 mb-3" animation="wave" type="avatar" :count="1" height="175px" width="175px"/>
    </div>
  </div>
</template>

<script>
import CustomRadialChart from './CustomRadialChart.vue'
import DoubleSlider from './DoubleSlider.vue'
import CustomSkeleton from './CustomSkeleton.vue'

export default {
  data(){
    return{
    }
  },
  components:{
    CustomRadialChart,
    DoubleSlider,
    CustomSkeleton
  },
  props:{
    userDetails: {
      type: Object,
      required: true
    },
    myTime:{
      typeof:Number,
      required:true
    },
    avgTime:{
      typeof:Number,
      required:true
    },
    radialData:{
      typeof:Array,
      required:true
    },
    loading:{
      typeof:Boolean,
      required:true
    }
  },
  methods:{
    

  },
  mounted(){
  },
  
}
</script>



<style scoped lang="scss">
.user-details{
  text-align: left;
  h1{
    font-weight: bold;
  }
  .relative{
    position: relative;
  }
  .absolute{
    position: absolute;
  }
  .time-spent{
    top: 93px;
    color: #c0c0c0;
    font-weight: 100;
  }
  .data-my-avg::before{
    background-color: rgba(var(--vs-primary),100)
  }
  .data-avg::before{
    background-color: white;
  }
  h5::before{
    content: '';
    border-radius: 50%;
    height: 15px;
    width: 15px;
    margin-right: 5px;
    display: inline-block;
  }
  .primary-color{
    color: rgba(var(--vs-primary),100)
  }
}
</style>